import React from "react";

/**
 * Section heading with optional eyebrow, subtitle, and right-aligned action slot.
 *
 *   <Title eyebrow="Collection" label="My Music" subtitle="14 playlists" action={<Buttons />} />
 *
 * If only `label` is provided, renders as a single bold heading underlined by a
 * thin neutral rule — matches the hardware-console section vocabulary.
 */
const Title = ({ eyebrow, label, subtitle, action }) => {
  const hasMeta = Boolean(eyebrow || subtitle || action);

  return (
    <header
      className={`flex items-end justify-between gap-4 ${hasMeta ? "mb-3 md:mb-4" : "mb-2 md:mb-3"} pb-2 border-b border-neutral-800`}
    >
      <div className="min-w-0">
        {eyebrow && (
          <div className="text-[9px] uppercase tracking-[0.3em] text-text-muted font-semibold mb-1">
            {eyebrow}
          </div>
        )}
        <h2 className="text-base md:text-lg font-bold text-text leading-none tracking-tight truncate">
          {label}
        </h2>
        {subtitle && (
          <div className="text-[11px] text-text-muted mt-1 font-mono tabular-nums">
            {subtitle}
          </div>
        )}
      </div>
      {action && <div className="shrink-0 flex items-center gap-2">{action}</div>}
    </header>
  );
};

export default Title;
